import { render, staticRenderFns } from "./AvastAnitiVirusEmail.vue?vue&type=template&id=27f7fc84&scoped=true&"
import script from "./AvastAnitiVirusEmail.vue?vue&type=script&lang=ts&"
export * from "./AvastAnitiVirusEmail.vue?vue&type=script&lang=ts&"
import style0 from "./AvastAnitiVirusEmail.vue?vue&type=style&index=0&id=27f7fc84&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f7fc84",
  null
  
)

export default component.exports